import { inject } from 'mobx-react';
import Component from './component';
import './index.scss';

const mapProps = ({ Store }) => ({
  loading: Store.isImLoading,
});

export default inject(mapProps)(Component);
